import { Link } from "react-router-dom";

import LogoDark from "components/Image/Logo/Dark";
import { APP_URLS } from "settings";

const HeaderUnauthenticated = () => {
  return (
    <header className="bg-white">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <Link to={APP_URLS.DASHBOARD} className="-m-1.5 p-1.5">
          <span className="sr-only">Abound</span>
          <LogoDark />
        </Link>
      </nav>
    </header>
  );
};

export default HeaderUnauthenticated;
